import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackMortgageBrokerBannerClick(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'Mortgage_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'mortgage',
        bannerName: 'Баннер "Циан.Ипотека для профи"',
        trapid: 'Баннер "Циан.Ипотека для профи"',
        source,
      },
    },
    sc: jsonQuery,
  });
}

export function trackMortgageBrokerBannerShow(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'Mortgage_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'mortgage',
        bannerName: 'Баннер "Циан.Ипотека для профи"',
        trapid: 'Баннер "Циан.Ипотека для профи"',
        source,
      },
    },
    sc: jsonQuery,
  });
}
